import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import state from './state'
import actions from './actions'
import mutations from './mutations'
import * as getters from './getters'
import * as services from '../services'

Vue.use(Vuex)

const store = new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
  plugins: [
    createPersistedState({
      paths: [
        'adminStatus',
        'userId',
        'userName'
      ]
    })
  ]
})

// Services custom event listeners
services.packinstalledService.on('refreshData', packinstalled => {
  store.commit('FETCH_PACKINSTALLEDSAUVEGARDE', packinstalled.data)
})

services.servicemonitoringService.on('refreshData', servicemonitoring => {
  store.commit('FETCH_SERVICEMONITORING', servicemonitoring.data)
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js